import { useEffect, useState } from "react";
import { getExecutionSubGroupDetail } from "../services/executionSubGroup";

interface IuseFetchExecutionSubGroup {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  currentExecutionSubGroupId: any;
}

const useFetchExecutionSubGroupById = ({
  setIsLoading,
  currentExecutionSubGroupId,
}: IuseFetchExecutionSubGroup) => {
  const [executionSubGroupData, setExecutionSubGroupData] = useState<any>({});
  useEffect(() => {
    setIsLoading(true);
    const getExecutionSubGroupData = async () => {
      try {
        const result =
          currentExecutionSubGroupId > 0 &&
          (await getExecutionSubGroupDetail({ currentExecutionSubGroupId }));
        setExecutionSubGroupData(result);
      } catch (err) {
        setExecutionSubGroupData({});
      } finally {
        setIsLoading(false);
      }
    };
    getExecutionSubGroupData();
  }, [currentExecutionSubGroupId]);

  return [executionSubGroupData];
};

export default useFetchExecutionSubGroupById;
